import AreaWebsiteCreate from './Create';
import AreaWebsiteEdit from './Edit';
import AreaWebsiteShow from './Show';

export default {
    create: AreaWebsiteCreate,
    edit: AreaWebsiteEdit,
    show: AreaWebsiteShow,
};
